import React from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { CAP_TABLE_SLUG } from 'common/constants/cap-table';

const GoToCapTable = ({ capTableURL }: { capTableURL: string }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => {
        const parsedQuery = queryString.parse(location.search);
        const search = queryString.stringify({ ...parsedQuery, tab: CAP_TABLE_SLUG });
        navigate({ pathname: capTableURL, search });
      }}
      startIcon={<ArrowBackIcon />}>
      Add Security
    </Button>
  );
};

export default GoToCapTable;
